export { HireAIAuthor } from "./pages/HireAIAuthorManagement";
